export default __webpack_public_path__ + "static/media/img_baseCrochet_grey.f20d7ffd.jpg";